/**
 * Scroll locking for full-screen overlays.
 *
 * MotionProvider registers its Lenis instance here so the overlay can pause
 * smooth scrolling without the two components needing to know about each other.
 */

type Scroller = { stop: () => void; start: () => void };

let scroller: Scroller | null = null;
let locks = 0;

export function registerScroller(instance: Scroller | null) {
  scroller = instance;
}

export function lockScroll() {
  if (locks++ > 0) return;

  const root = document.documentElement;
  // Reserve the scrollbar's width so locking does not shift the layout.
  const gutter = window.innerWidth - root.clientWidth;

  root.style.overflow = "hidden";
  if (gutter > 0) root.style.paddingRight = `${gutter}px`;

  scroller?.stop();
}

export function unlockScroll() {
  if (locks === 0) return;
  if (--locks > 0) return;

  const root = document.documentElement;
  root.style.overflow = "";
  root.style.paddingRight = "";

  scroller?.start();
}
